import { EgretLoadable } from "egret";
import { authRoles } from "../../auth/authRoles";

const TSYSForm = EgretLoadable({
  loader: () => import("./TSYSForm")
});

const CardnetForm = EgretLoadable({
  loader: () => import("./CardnetForm")
});

const PaymentechForm = EgretLoadable({
  loader: () => import("./PaymentechForm")
});

const OmahaForm = EgretLoadable({
  loader: () => import("./OmahaForm")
});

const NashvilleForm = EgretLoadable({
  loader: () => import("./NashvilleForm")
});

const LoopbackForm = EgretLoadable({
  loader: () => import("./LoopbackForm")
});

const EpxForm = EgretLoadable({
  loader: () => import("./EpxForm")
});

const MerchantList = EgretLoadable({
  loader: () => import("./MerchantList")
});

const MerchantListNoTerms = EgretLoadable({
  loader: () => import("./MerchantListNoTerms")
});
const MerchantListWithTerms = EgretLoadable({
  loader: () => import("./MerchantListWithTerms")
});

const adminRoutes = [
  {
    path: "/admin/merchants/search",
    component: MerchantList,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/terms/no",
    component: MerchantListNoTerms,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/terms/yes",
    component: MerchantListWithTerms,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/vital/add",
    component: TSYSForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/omaha/add",
    component: OmahaForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/cardnet/add",
    component: CardnetForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/paymentech/add",
    component: PaymentechForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/nashville/add",
    component: NashvilleForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/lopback/add",
    component: LoopbackForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/epx/add",
    component: EpxForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/vital/:id",
    component: TSYSForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/omaha/:id",
    component: OmahaForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/loopback/:id",
    component: LoopbackForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/cardnet/:id",
    component: CardnetForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/paymentech/:id",
    component: PaymentechForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/nashville/:id",
    component: NashvilleForm,
    auth: authRoles.support
  },
  {
    path: "/admin/merchants/epx/:id",
    component: EpxForm,
    auth: authRoles.support
  }
];

export default adminRoutes;
